// Splits a decoded SSE byte stream into lines, in time linear in its length.
//
// The chat used to append each network chunk to one string buffer and
// re-split the whole buffer every time. A tool output can be one multi-MB
// line (a screenshot's base64 is ~630KB; the limit is 7MB), which arrives as
// hundreds of chunks, so every chunk re-scanned everything before it:
// quadratic, about five seconds of blocked main thread for a 5MB line in
// 1KB chunks (#1346 item 3, "page unresponsive"). Now only the new chunk is
// scanned, and the pieces of an unfinished line are joined once, when its
// newline arrives.
export class SSELineBuffer {
  private pending: string[] = []

  /** Feed one decoded chunk; returns the complete lines it finished. */
  push(chunk: string): string[] {
    let nl = chunk.indexOf('\n')
    if (nl === -1) {
      if (chunk) this.pending.push(chunk)
      return []
    }
    const lines: string[] = []
    this.pending.push(chunk.slice(0, nl))
    lines.push(this.pending.length === 1 ? this.pending[0] : this.pending.join(''))
    this.pending = []
    let start = nl + 1
    while ((nl = chunk.indexOf('\n', start)) !== -1) {
      lines.push(chunk.slice(start, nl))
      start = nl + 1
    }
    if (start < chunk.length) this.pending.push(chunk.slice(start))
    return lines
  }

  /** What is left after the stream ended (a last line with no newline). */
  flush(): string {
    const rest = this.pending.join('')
    this.pending = []
    return rest
  }
}
